export interface Language {
  code: string;
  name: string;
  locale: string;
  dir: 'ltr' | 'rtl';
}

export const languages: Language[] = [
  { code: 'en', name: 'English', locale: 'en-US', dir: 'ltr' },
  { code: 'es', name: 'Español', locale: 'es-ES', dir: 'ltr' },
  { code: 'fr', name: 'Français', locale: 'fr-FR', dir: 'ltr' },
  { code: 'de', name: 'Deutsch', locale: 'de-DE', dir: 'ltr' },
  { code: 'it', name: 'Italiano', locale: 'it-IT', dir: 'ltr' },
  { code: 'pt', name: 'Português', locale: 'pt-PT', dir: 'ltr' },
  { code: 'pt-br', name: 'Português (BR)', locale: 'pt-BR', dir: 'ltr' },

  // The rest (alphabetical by label)
  { code: 'id', name: 'Bahasa Indonesia', locale: 'id-ID', dir: 'ltr' }, // Indonesian
  { code: 'ms', name: 'Bahasa Melayu', locale: 'ms-MY', dir: 'ltr' }, // Malay (general)
  { code: 'cs', name: 'Čeština', locale: 'cs-CZ', dir: 'ltr' }, // Czech
  { code: 'da', name: 'Dansk', locale: 'da-DK', dir: 'ltr' }, // Danish
  { code: 'et', name: 'Eesti', locale: 'et-EE', dir: 'ltr' }, // Estonian
  { code: 'tl', name: 'Filipino (Tagalog)', locale: 'tl-PH', dir: 'ltr' }, // Filipino
  { code: 'hr', name: 'Hrvatski', locale: 'hr-HR', dir: 'ltr' }, // Croatian
  { code: 'lv', name: 'Latviešu', locale: 'lv-LV', dir: 'ltr' }, // Latvian
  { code: 'lt', name: 'Lietuvių', locale: 'lt-LT', dir: 'ltr' }, // Lithuanian
  { code: 'hu', name: 'Magyar', locale: 'hu-HU', dir: 'ltr' }, // Hungarian
  { code: 'nl', name: 'Nederlands', locale: 'nl-NL', dir: 'ltr' }, // Dutch
  { code: 'nb', name: 'Norsk bokmål', locale: 'nb-NO', dir: 'ltr' }, // Norwegian Bokmål
  { code: 'pl', name: 'Polski', locale: 'pl-PL', dir: 'ltr' }, // Polish
  { code: 'ro', name: 'Română', locale: 'ro-RO', dir: 'ltr' }, // Romanian
  { code: 'sk', name: 'Slovenčina', locale: 'sk-SK', dir: 'ltr' }, // Slovak
  { code: 'sl', name: 'Slovenščina', locale: 'sl-SI', dir: 'ltr' }, // Slovenian
  { code: 'fi', name: 'Suomi', locale: 'fi-FI', dir: 'ltr' }, // Finnish
  { code: 'sv', name: 'Svenska', locale: 'sv-SE', dir: 'ltr' }, // Swedish
  { code: 'vi', name: 'Tiếng Việt', locale: 'vi-VN', dir: 'ltr' }, // Vietnamese
  { code: 'tr', name: 'Türkçe', locale: 'tr-TR', dir: 'ltr' }, // Turkish
  { code: 'el', name: 'Ελληνικά', locale: 'el-GR', dir: 'ltr' }, // Greek
  { code: 'bg', name: 'Български', locale: 'bg-BG', dir: 'ltr' }, // Bulgarian
  { code: 'th', name: 'ไทย', locale: 'th-TH', dir: 'ltr' }, // Thai
  { code: 'ar', name: 'العربية', locale: 'ar-SA', dir: 'rtl' }, // Arabic (MSA)
  { code: 'he', name: 'עברית', locale: 'he-IL', dir: 'rtl' }, // Hebrew
];
